<div class="loader-overlay" *ngIf="isLoading">
  <div class="loader-content">
    <div class="spinner-wrapper">
      <!-- Circular progress spinner -->
      <mat-progress-spinner mode="indeterminate" diameter="100" class="custom-spinner">
      </mat-progress-spinner>

      <!-- Logo image inside spinner -->
      <div class="spinner-logo">
        <img src="assets/images/NeoJobz_192_192.svg" alt="Logo" />
      </div>
    </div>

    <!-- Loading text -->
    <p class="loader-text">Loading...</p>
  </div>
</div>